import { Component, Listen, Prop, State, h } from '@stencil/core';
import { ConversationalSearchNewCovnersationFollowup } from '../../predefined/new-conversation-followup/new-conversation-followup';
import { getTermsAndConditionsSessionStorageValue, removeUIDSessionStorageValue } from '../../../conversational-search-logic/storage-manager/storage-manager-helpers';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-widget-conversational-search-messages-external-origin-mediator',
  styleUrl: 'external-origin-mediator.scss',
  shadow: false,
})
export class ConversationalSearchMessagesExternalOriginMediator {
  @Prop() readonly conversationalSearchBrandUrl: string;
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly searchQuery: string;
  @Prop() readonly language: string;
  @Prop() readonly country: string;

  @State() isTermsAccepted = false;
  @State() isNewConversation = false;

  @Listen('conversational-search:user-start-of-conversation', {
    target: 'window',
  })
  userQuestionStatetHandler() {
      this.isTermsAccepted = true;
  }

  @Listen('conversational-search:user-new-conversation', {
    target: 'window',
  })
  userNewConversationHandler() {
      this.isNewConversation = true;
  }

  connectedCallback() {
      removeUIDSessionStorageValue();
      if (getTermsAndConditionsSessionStorageValue()) {
        this.isNewConversation = true;
      }
  }

  private newConversationTemplate = () => (
    <uiaas-conversational-search-message-new-conversation
      labelProvider={(e, f) => this.labelProvider(e, f)}
      query={this.searchQuery}
    />
  );

  render() {
      if ((!getTermsAndConditionsSessionStorageValue() || this.isTermsAccepted) && !this.isNewConversation)
        return (
          <section>
            <uiaas-search-conversational-search-messages-wrapper labelProvider={(e, f) => this.labelProvider(e, f)}>
              <uiaas-search-conversational-search-message-terms-and-conditions-external-origin
                labelProvider={(e, f) => this.labelProvider(e, f)}
                query={this.searchQuery}
                country={this.country}
                language={this.language}
                conversationalSearchBrandUrl={this.conversationalSearchBrandUrl}
              />
            </uiaas-search-conversational-search-messages-wrapper>
            {this.isTermsAccepted ? (
              <span>
                <uiaas-search-conversational-search-messages-wrapper isQuestionVariant={true} labelProvider={(e, f) => this.labelProvider(e, f)}>
                  <span>{this.labelProvider('conversational.search.chat.terms.and.conditions.message.acceptance', 'I Accept Terms and Conditions')}</span>
                </uiaas-search-conversational-search-messages-wrapper>
                <ConversationalSearchNewCovnersationFollowup labelProvider={(e, f) => this.labelProvider(e, f)}/>
              </span>
            ) : (
              ''
            )}
          </section>
        );

      if (this.isNewConversation) return this.newConversationTemplate();
  }
}
